import { Component, ViewEncapsulation } from '@angular/core';
import { Bullet_List } from '../templates/bullet-list';
import { Card_Flip } from '../templates/card-flip';
import { Checkbox_List } from '../templates/checkbox-list';
import { Conversation_Container } from '../templates/conversation-container';
import { Key_Concept } from '../templates/key-concept';
import { Number_List } from '../templates/number-list';
import { One_Third_Page } from '../templates/one-third-page';
import { Open_Fields } from '../templates/open-fields';
import { Plain_Text } from '../templates/plain-text';
import { Quiz } from '../templates/quiz';
import { What_People_Say } from '../templates/what-people-say';
import { SafeHtmlPipe } from './safe.pipe';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
  imports: [SafeHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class TemplatesComponent {
  cardFlip = Card_Flip;
  whatPeopleSay = What_People_Say;
  oneThirdPage = One_Third_Page;
  openFields = Open_Fields;
  checkboxList = Checkbox_List;
  quiz = Quiz;
  plainText = Plain_Text;
  keyConcept = Key_Concept;
  conversationContainer = Conversation_Container;
  numberList = Number_List;
  bulletList = Bullet_List;
  clickValue: string;

  private loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }
}
